module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAATUlEQVQ4jWNgGGjAyMDAwLBp06b/2CS9uhvwamY5fI6RBcbx9fXFUPCXgAEMDAwMTARVDH8DWPBKOnLg1314MHiBemGwefNmSs0aqgAAW8AMNOhEnA8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MG.png
// module id = 1205
// module chunks = 0